import format from 'date-fns/format';
import getDay from 'date-fns/getDay';
import isSameMonth from 'date-fns/isSameMonth';

// Steps 3-8 are the only blue tokens that stay a background in both themes,
// so the count keeps AA contrast against text-n-slate-12 in light and dark mode.
// Keep these as complete literals so Tailwind's scanner includes every class.
export const CELL_INTENSITY_CLASSES = [
  'bg-n-blue-3 text-n-slate-12',
  'bg-n-blue-5 text-n-slate-12',
  'bg-n-blue-6 text-n-slate-12',
  'bg-n-blue-7 text-n-slate-12',
  'bg-n-blue-8 text-n-slate-12',
];

export const DAY_LABEL_FORMAT = 'dd/MM';
export const EMPTY_CELL = '·';

// From two weeks on, day columns share the width, too narrow for dd/MM: they show the day
// alone, with the month on the first column and wherever a new month starts.
export const COMPACT_DAY_LABELS_FROM = 14;

export const isCompactDayRange = dates =>
  dates.length >= COMPACT_DAY_LABELS_FROM;

const startsMonth = (dates, index) =>
  index === 0 || !isSameMonth(dates[index], dates[index - 1]);

export const dayHeaderLabel = (dates, index) => {
  if (!isCompactDayRange(dates)) {
    return format(dates[index], DAY_LABEL_FORMAT);
  }

  return format(dates[index], startsMonth(dates, index) ? 'd/M' : 'd');
};

// A month marker such as 1/10 takes the smallest size, so it stays inside a narrow column.
export const dayHeaderTextClass = (dates, index) => {
  if (!isCompactDayRange(dates)) {
    return '';
  }

  return startsMonth(dates, index) ? 'text-xxs' : 'text-xs';
};

export const intensityClassFor = (value, maxValue) => {
  if (!value) {
    return '';
  }

  const ratio = maxValue ? value / maxValue : 0;
  const level = Math.max(
    0,
    Math.min(
      CELL_INTENSITY_CLASSES.length - 1,
      Math.ceil(ratio * CELL_INTENSITY_CLASSES.length) - 1
    )
  );
  return CELL_INTENSITY_CLASSES[level];
};

export const isWeekend = date => [0, 6].includes(getDay(date));
